module.exports = __webpack_public_path__ + "static/img/2_2.94b8e22f.jpg";